import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

const SHORTCUTS_SECTIONS = [
  /* eslint-disable global-require */
  {
    key: 'services',
    title: 'navigation.services',
    sections: [
      {
        key: 'dine_in',
        title: 'selling-types.types.dinein',
        route: 'admin:branches-management',
        featureKey: 'dine_in',
        index: 4,
        permission: SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
      },
      {
        key: 'delivery',
        title: 'selling-types.types.delivery',
        route: 'admin:branches-management',
        featureKey: 'delivery',
        index: 5,
        permission: SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
      },
      {
        key: 'pickup',
        title: 'selling-types.types.car_pickup',
        route: 'admin:branches-management',
        featureKey: 'pickup',
        index: 6,
        permission: SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
      },
    ],
  },
  {
    key: 'tools',
    title: 'navigation.tools',
    sections: [
      {
        key: 'payment_methods',
        title: 'payment-methods.payment-methods',
        route: 'admin:branches-management',
        featureKey: null,
        index: 9,
        permission: SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
      },
      {
        key: 'qr_codes',
        title: 'qr-code.qr-codes',
        route: 'admin:qr',
        featureKey: null,
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.GENERAL_QR_MANAGE,
      },
      {
        key: 'devices',
        title: 'navigation.devices',
        route: 'admin:devices',
        featureKey: 'devices',
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.GENERAL_DEVICES_VIEW,
      },
      {
        key: 'widget',
        title: 'navigation.widget',
        route: 'admin:widget',
        featureKey: null,
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
      },
    ],
  },
  {
    key: 'appearance',
    title: 'navigation.appearance',
    sections: [
      {
        key: 'website_themes',
        title: 'design.qr.qr-menu-themes',
        route: 'admin:design:qr',
        featureKey: 'themes',
        index: 0,
        permission: [
          SUBUSER_PERMISSION_SLUGS.SETTINGS_ACCESS,
          SUBUSER_PERMISSION_SLUGS.SETTINGS_THEMES_MANAGE,
        ],
      },
      {
        key: 'ipad_themes',
        title: 'design.tablet.ipad-themes',
        route: 'admin:design:tablet',
        featureKey: 'themes',
        index: 0,
        permission: [
          SUBUSER_PERMISSION_SLUGS.SETTINGS_ACCESS,
          SUBUSER_PERMISSION_SLUGS.SETTINGS_THEMES_MANAGE,
        ],
      },
      {
        key: 'receipt',
        title: 'design.receipt-settings',
        route: 'admin:design:receipt-setting',
        featureKey: null,
        index: 0,
        permission: [
          SUBUSER_PERMISSION_SLUGS.BRANCHES_RECEIPT_MANAGE,
          SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
        ],
      },
    ],
  },
  {
    key: 'users',
    title: 'navigation.users',
    sections: [
      {
        key: 'users',
        title: 'navigation.users',
        route: 'admin:users-wizard',
        permission: SUBUSER_PERMISSION_SLUGS.SUBUSERS_VIEW,
        index: 0,
      },
      {
        key: 'roles',
        title: 'roles.title',
        route: 'admin:users-wizard',
        permission: SUBUSER_PERMISSION_SLUGS.ROLES_VIEW,
        index: 1,
      },
      {
        key: 'activity_logs',
        title: 'activity-logs.activity-logs',
        route: 'admin:users-wizard',
        permission: SUBUSER_PERMISSION_SLUGS.AUDITOR_ACTIVITY_LOGS_VIEW,
        index: 2,
      },
    ],
  },
  {
    key: 'subscription',
    title: 'navigation.subscription',
    ownerOnly: true,
    sections: [
      {
        key: 'manage_subscription',
        title: 'subscription.manage-subscription',
        route: 'billing:manage-subscription',
        index: 0,
      },
      {
        key: 'plans',
        title: 'subscription.plans',
        route: 'billing:plans',
        index: 0,
      },
      {
        key: 'billing',
        title: 'subscription.billing',
        route: 'billing:billing-information',
        index: 0,
      },
    ],
  },
  {
    key: 'addons',
    title: 'navigation.addons',
    ownerOnly: true,
    sections: [
      {
        key: 'mobile-app',
        title: 'mobile.mobile-section',
        route: 'admin:addons:view',
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
      },
      {
        key: 'google',
        title: 'google-menu.title',
        route: 'admin:addons:view',
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
      },
      {
        key: 'whatsapp',
        title: 'profile.wp_label',
        route: 'admin:addons:view',
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
      },
      {
        key: 'branded_domain',
        title: 'navigation.domains',
        route: 'admin:addons:view',
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
      },
      {
        key: 'pixels',
        title: 'navigation.analytics-pixels',
        route: 'admin:addons:view',
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
      },
      {
        key: 'ok_pos',
        title: 'navigation.cashier-app',
        route: 'admin:addons:view',
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
      },
      {
        key: 'go_to_store',
        title: 'navigation.go-to-store',
        route: 'admin:store',
        index: 0,
        permission: SUBUSER_PERMISSION_SLUGS.INTEGRATIONS_VIEW,
      },
    ],
  },
]
export default SHORTCUTS_SECTIONS

export const SHORTCUTS_ICONS = {
  dine_in: require('@/assets/images/icons/shortcuts/dinein.svg'),
  pickup: require('@/assets/images/icons/shortcuts/pickup.svg'),
  delivery: require('@/assets/images/icons/shortcuts/delivery.svg'),
  queue: require('@/assets/images/icons/shortcuts/queue.svg'),
  queue_upgrade: require('@/assets/images/icons/shortcuts/queue-upgrade.svg'),
  reservations: require('@/assets/images/icons/shortcuts/reservation.svg'),
  reservations_upgrade: require('@/assets/images/icons/shortcuts/reservation-upgrade.svg'),
  payment_methods: require('@/assets/images/icons/shortcuts/payment.svg'),
  qr_codes: require('@/assets/images/icons/shortcuts/qrCode.svg'),
  devices: require('@/assets/images/icons/shortcuts/ipadTheme.svg'),
  widget: require('@/assets/images/icons/shortcuts/widget.svg'),
  website_themes: require('@/assets/images/icons/shortcuts/websitetheme.svg'),
  website_themes_upgrade: require('@/assets/images/icons/shortcuts/websitetheme-upgrade.svg'),
  ipad_themes: require('@/assets/images/icons/shortcuts/ipadTheme.svg'),
  ipad_themes_upgrade: require('@/assets/images/icons/shortcuts/ipadTheme-upgrade.svg'),
  mobile_themes: require('@/assets/images/icons/shortcuts/mobileTheme.svg'),
  mobile_themes_upgrade: require('@/assets/images/icons/shortcuts/mobileTheme-upgrade.svg'),
  receipt: require('@/assets/images/icons/shortcuts/receipt.svg'),
  users: require('@/assets/images/icons/shortcuts/users.svg'),
  roles: require('@/assets/images/icons/shortcuts/roles.svg'),
  activity_logs: require('@/assets/images/icons/shortcuts/activity.svg'),
  manage_subscription: require('@/assets/images/icons/shortcuts/subscription.svg'),
  plans: require('@/assets/images/icons/shortcuts/plans.svg'),
  billing: require('@/assets/images/icons/shortcuts/billing.svg'),
  mobile_app: require('@/assets/images/icons/shortcuts/mobileTheme.svg'),
  google: require('@/assets/images/icons/shortcuts/google.svg'),
  whatsapp: require('@/assets/images/icons/shortcuts/whatsapp.svg'),
  branded_domain: require('@/assets/images/icons/shortcuts/domain.svg'),
  pixels: require('@/assets/images/icons/shortcuts/analytics.svg'),
  ok_pos: require('@/assets/images/icons/shortcuts/cashier.svg'),
  go_to_store: require('@/assets/images/icons/shortcuts/store.svg'),

}
export const UPGRADED_SHORTCUTS = ['dine_in', 'delivery', 'pickup', 'reservations', 'delivery', 'queue', 'mobile-themes']
